<div
  class="player"
  [class.mini]="isMini()"
  [ngClass]="{ 'radio-player--on-radio-page': isPage() }"
  role="region"
  aria-label="Reproductor Opus Liber"
>
  <div class="logo-cover d-flex">
    <!-- Logo -->
    <div class="logo flex-fill">
      <div>
        <img src="img/icon-violin.webp" width="40" alt="Opus Liber" />
      </div>

      <div class="logo-text">
        <div class="brand">Opus<br />Liber</div>
        <div class="tagline">MÚSICA E IDEAS</div>
      </div>
    </div>

    <!-- Cover placeholder -->
    <div class="cover">
      <div id="sonic_art_full" class="cover-art"></div>
    </div>
  </div>

  <!-- Info + transport controls -->
  <div class="stage d-block d-md-flex py-2 py-md-0">
    <div class="info">
      <div class="d-flex align-items-center mb-2">
        <div class="on-air mb-0 w-100">AL AIRE</div>
        <div class="badge d-inline-block d-md-none ms-auto">EN VIVO</div>
      </div>
      <p class="track" id="sonic_title"></p>
    </div>

    <div class="controls d-flex d-md-block mr-0 mr-md-5 pt-2">
      <div class="controls-top">
        <button
          class="btn-circle play-btn"
          type="button"
          aria-label="Reproducir"
          (click)="togglePlay()"
        >
          @if (!isPlaying()) {
            <svg viewBox="0 0 24 24" fill="#d4af37">
              <path d="M8 5v14l11-7z" />
            </svg>
          } @else {
            <svg viewBox="0 0 24 24" fill="#d4af37">
              <path d="M6 5h4v14H6zM14 5h4v14h-4z" />
            </svg>
          }
        </button>

        <button
          class="btn-circle live-btn"
          type="button"
          aria-label="En vivo"
          [class.pulsing]="isPlaying()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8">
            <circle cx="12" cy="12" r="2.2" fill="#fff" stroke="none" />
            <path d="M8.5 8.5a5 5 0 0 0 0 7" />
            <path d="M15.5 8.5a5 5 0 0 1 0 7" />
            <path d="M5.8 5.8a9 9 0 0 0 0 12.4" />
            <path d="M18.2 5.8a9 9 0 0 1 0 12.4" />
          </svg>
        </button>

        <span class="badge d-none d-md-block">EN VIVO</span>
      </div>

      <div class="volume flex-fill">
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M3 10v4h4l5 5V5L7 10H3z" />
          <path d="M16.5 12a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z" />
        </svg>
        <input
          type="range"
          min="0"
          max="100"
          [value]="volume()"
          [style.--val]="volume() + '%'"
          (input)="onVolumeInput($event)"
          aria-label="Volumen"
        />
      </div>
    </div>
  </div>

  <div class="minimize-panel px-2 mt-2 w-100">
    <div>
      <img src="img/opus_iber_logo.webp" width="65" alt="Opus Liber" />
    </div>
    <div class="text-center mt-2">
      <div class="badge mx-auto">EN VIVO</div>
    </div>
  </div>

  <div class="minimize">
    <button class="border-0" type="button" (click)="toggleMini()">
      @if (!isMini()) {
        <i class="fas fa-compress-arrows-alt"></i>
      } @else {
        <i class="fas fa-expand-arrows-alt"></i>
      }
    </button>
  </div>
</div>

<audio #audioRef preload="none" (play)="onPlay()" (pause)="onPause()"></audio>
